import script from "./EmissaoCertidoes.vue?vue&type=script&setup=true&lang=js"
export * from "./EmissaoCertidoes.vue?vue&type=script&setup=true&lang=js"

import "./EmissaoCertidoes.vue?vue&type=style&index=0&id=6cb1148d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb1148d"]])

export default __exports__